export interface ICommonFormDropdownObj {
    identity: FormIdentity;
    field: ICommonFormField;
    formObj : ICommonFormField[];
  }

  export interface IDropdown {
    label: string;
    value: string;
    id?: string | number;
  }

  export interface IValidation {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
  }
  export interface ICommonFormField {
    name: string,
    label: string,
    type: string,
    options?: IDropdown [],
    validations: IValidation,
    value: string | number | IDropdown | boolean | null | undefined;
  };
export enum FormIdentity {
    familyMemberDetails = "Family Member Details",
    nomineeMemberDetails = "Nominee Details",
    coApplicantDetails = "Co-Applicant Details"
}
